<h5><fa-icon [icon]="['fas','user']"> </fa-icon>  {{"TRANS_REMOTE_BUY.TRANS_BASIC_INFO" | translate}}</h5>
<form [formGroup]="userForm">
	<div class="row">
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_NAME" | translate}}</div>
			<div>
				<input type="name" class="form-control" formControlName="name" [readOnly]="readonlyState['name']">
			</div>
			<div class="error text-danger" *ngIf="userForm.controls.name.invalid">
				{{"TRANS_REMOTE_BUY.TRANS_NAME_ERROR" | translate}}
			</div>
		</div>
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_LAST_NAME" | translate}}</div>
			<div>
				<input type="lastName" class="form-control" formControlName="lastName" [readOnly]="readonlyState['lastName']">
				<div class="error text-danger" *ngIf="userForm.controls.lastName.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_LAST_NAME_ERROR" | translate}}
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">Email</div>
			<div>
				<input type="email" class="form-control" formControlName="email" [readOnly]="readonlyState['email']">
				<div class="error text-danger" *ngIf="userForm.controls.email.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_EMAIL_ERROR" | translate}}
				</div>
			</div>
		</div>
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_PHONE" | translate}}</div>
			<div>
				<input type="text" class="form-control" formControlName="phone" [readOnly]="readonlyState['phone']">
				<div class="error text-danger" *ngIf="userForm.controls.phone.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_PHONE_ERROR" | translate}}
				</div>
			</div>
		</div>
	</div>
</form>